var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c("regresar-button"),
      _vm._v(" "),
      _c("div", { staticClass: "page-header" }, [
        _c("h2", {
          domProps: {
            textContent: _vm._s(
              _vm.$t("apeironGwApp.formalizarBecas.firmas.title")
            ),
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "no-padding" },
            [
              _c("filtros", {
                attrs: {
                  showMostrarConvocatoria: _vm.muestraTipoSolucion,
                  soluciones: _vm.solucions,
                  solucion: _vm.solucion,
                },
                on: {
                  "update:solucion": function ($event) {
                    _vm.solucion = $event
                  },
                  buscar: _vm.buscaSolicitudes,
                },
                scopedSlots: _vm._u([
                  {
                    key: "botonBuscar",
                    fn: function () {
                      return [
                        _vm.show
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("global.process.search.searching")
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("entity.action.search")) +
                                  "\n          "
                              ),
                            ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.muestraFirmables
            ? _c(
                "b-col",
                [
                  _vm.muestraFirmables
                    ? _c("div", { staticClass: "solicitud-info mt-3" }, [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.formalizarBecas.firmas.solicitud"
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("code", [_vm._v(_vm._s(_vm.idSolicitud))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mostrarTextoAsignacion
                    ? _c("div", { staticClass: "solicitud-info mt-3" }, [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.formalizarBecas.firmas.estado"
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("code", [_vm._v(_vm._s(_vm.estadoSolicitud))]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.formalizarBecas.firmas.estado2"
                              )
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    [
                      !_vm.mostrarTextoGenerarPdf
                        ? _c("h3", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("formalizacion.convenio")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarTextoGenerarPdf
                        ? _c("h3", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("formalizacion.anexo")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _vm.mostrarBotonUnaFirmaConvenio &&
                          !_vm.mostrarTextoGenerarPdf
                            ? _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "move-right",
                                      attrs: {
                                        variant: "primary",
                                        size: "md",
                                        disabled: _vm.show || _vm.pdfFirma,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generarVisualizar(
                                            _vm.idSolicitud
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.show
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.load.generando"
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.vistaPrevia"
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c("b-icon", {
                                        staticClass: "mr-2",
                                        attrs: { icon: "binoculars" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.mostrarBotonUnaFirmaConvenio &&
                                    !_vm.mostrarTextoGenerarPdf,
                                  expression:
                                    "mostrarBotonUnaFirmaConvenio && !mostrarTextoGenerarPdf",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "move-right",
                                  attrs: {
                                    variant: "outline-primary",
                                    disabled: _vm.show || _vm.pdfFirma,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.mostrarModalPasswordDocumentoIndividual()
                                    },
                                  },
                                },
                                [
                                  _vm.pdfFirma
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.load.generando"
                                            )
                                          ) + " "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "formalizacion.firmarDocumento"
                                              )
                                            )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c("b-icon", { attrs: { icon: "pen-fill" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.mostrarBotonUrlDocumentoConvenio
                            ? _c(
                                "b-col",
                                { staticClass: "line-break text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-secondary",
                                        href: _vm.urlconvenio,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("formalizacion.verConvenio")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-icon-file-earmark-pdf-fill", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mostrarBotonUrlDocumentoAnexo
                            ? _c(
                                "b-col",
                                { staticClass: "line-break text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-secondary",
                                        href: _vm.urlanexo,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("formalizacion.verAnexo")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-icon-file-earmark-pdf-fill", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      ref: "modal",
                      attrs: {
                        title: _vm.$t("bandeja.generarDoc"),
                        "ok-title": _vm.$t("documentos.modalButtonOk"),
                        "cancel-title": _vm.$t("documentos.modalButtonCancel"),
                      },
                      on: {
                        ok: function ($event) {
                          return _vm.generarDocumento($event)
                        },
                      },
                    },
                    [
                      _c(
                        "form",
                        { ref: "form" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "global.menu.entities.passwordDocumento"
                                ),
                                "label-for": "name-input",
                                "invalid-feedback": _vm.$t(
                                  "documentos.passwordRequerido"
                                ),
                                state: _vm.estadoPassword,
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: _vm.mostrarPassword
                                        ? "text"
                                        : "password",
                                      "aria-placeholder": _vm.$t(
                                        "documentos.passwordPlaceholder"
                                      ),
                                      required: "",
                                      state: _vm.estadoPassword,
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function ($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName:
                                                "v-b-tooltip.hover.right",
                                              value: _vm.$t(
                                                "documentos.mostrarPassword"
                                              ),
                                              expression:
                                                "$t('documentos.mostrarPassword')",
                                              modifiers: {
                                                hover: true,
                                                right: true,
                                              },
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.mostrarPassword =
                                                !_vm.mostrarPassword
                                            },
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "eye" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("visualizador-pdf", {
            attrs: {
              id: "visualizador-solicitud",
              contenidoBase64: _vm.contenidoBase64,
              mostrar: _vm.pdfReady,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }